import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "./Blog.css";
import { blogPosts } from "./blogData";

const Blog = () => {
    return (
        <>
            <Helmet>
                <title>PRT Academy Blog | IT Career and Skills</title>
                <meta
                    name="description"
                    content="Explore IT career, technical skills, job search and internship guidance from PRT Academy."
                />
            </Helmet>

            <section className="blog-page">
                <div className="page-badge">PRT Academy Blog</div>
                <h1>
                    Learn Something <span>New</span>
                </h1>
                <p className="page-intro">
                    Explore development, career and placement-related resources
                    from PRT Academy.
                </p>

                <div className="blog-grid">
                    {blogPosts.map((blog) => (
                        <Link
                            className="blog-card"
                            key={blog.id}
                            to={`/blog/${blog.slug}`}
                        >
                            <div
                                className="blog-card-image"
                                style={{ backgroundImage: `url(${blog.cardImage})` }}
                                aria-hidden="true"
                            >
                            </div>
                            <div className="blog-card-content">
                                <span className="blog-category">
                                    {blog.category}
                                </span>
                                <h2>{blog.title}</h2>
                                <p>{blog.excerpt}</p>
                                <span className="click-text">
                                    Read article &rarr;
                                </span>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>
        </>
    );
};

export default Blog;